<template>
  <div class="h-full p-8 pt-0 w-full overflow-auto">
    <DataGetter
      v-if="isLoading"
      @dataAvailable="
        data => {
          payments = data?.metaData?.payments || []
          totalPages = Math.ceil(data?.metaData?.total / 10)
          this.isLoading = false
        }
      "
      :searchQuery="{
        searchText: typedSearchValue,
        page: currentPage,
        limit: 10,
        status: activeStatus
      }"
      :debounceDelay="500"
      contentId="searchTransaction"
      eventToListen="none"
    />

    <!-- <TransactionsGetter
      :searchText="typedSearchValue"
      :page="currentPage"
      @loading="setPageIsLoading"
      @result="
        data => {
          payments = data || []
          this.isLoading = false
        }
      "
    /> -->
    <div
      class="flex flex-col md:flex-row w-full justify-between md:items-center gap-4 sticky top-0 pt-8 pb-4 bg-[#f4f4f5] z-[2]"
    >
      <div class="text-4xl title-color">Paiements</div>
      <div class="flex gap-12 items-center">
        <div class="w-[30rem] flex items-center relative">
          <input
            type="search"
            class="w-full pl-12 py-4 rounded-2xl"
            placeholder="Rechercher"
            v-model="typedSearchValue"
          />
          <div
            class="w-6 h-6 text-[#30225C] absolute left-4 pointer-events-none"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
    <div class="py-4"></div>
    <div class="sticky top-16 bg-[#f4f4f5] py-3 pt-6">
      <div class="flex justify-between items-center">
        <div
          class="w-full md:w-auto grid grid-cols-3 md:flex gap-4 p-1 bg-white rounded-2xl"
        >
          <button
            class="relative px-4 py-2 rounded-xl flex items-center justify-center"
            v-for="(status, i) in statuses"
            :key="i"
            @click="activeStatus = status.id"
          >
            <div
              :class="{
                'w-full h-full bg-primary': activeStatus == status.id,
                'w-0 h-0 bg-transparent': activeStatus !== status.id,
              }"
              class="duration-300 absolute !w-full !h-full rounded-xl "
            ></div>
            <div
              class="relative"
              :class="{
                'text-white': activeStatus == status.id,
                '': activeStatus !== status.id,
              }"
            >
              {{ status.name }}
            </div>
          </button>
        </div>
      </div>
    </div>
    <div class="py-2"></div>
    <div class="w-full relative" v-if="isLoading || payments?.length > 0">
      <div class="overflow-auto">
        <div>
          <div
            class="flex items-center justify-between p-4 gap-8 rounded-2xl text-sm uppercase"
          >
            <div class="flex items-center gap-4 w-[16rem] min-w-[16rem]">
              Détails du paiement
            </div>

            <div class="flex gap-6 w-[8rem] min-w-[8rem]">Clients</div>

            <div class="flex gap-6 w-[8rem] min-w-[8rem]">Date</div>

            <div class="flex gap-6 w-[8rem] min-w-[8rem]">Méthode</div>

            <div class="flex gap-6 w-[6rem] min-w-[6rem] justify-center">
              Status
            </div>

            <div class="flex gap-6 w-[16rem] min-w-[16rem]">Détail</div>

            <div
              class="flex items-center gap-2 w-[3rem] min-w-[3rem] justify-end pr-4"
            >
              Actions
            </div>
          </div>
        </div>

        <div class="flex flex-col gap-4">
          <div
            v-for="(payment, index) in isLoading ? shimmerPayments : payments"
            :key="index"
            :class="{ shimmerElement: payment.shimmer }"
            class="flex items-center justify-between p-4 py-2 rounded-2xl gap-8 [&>div]:relative h-[4lh]"
          >
            <div
              class="pointer-events-none !absolute min-w-8 left-0 w-full rounded-xl h-[4lh] bg-white p-"
            ></div>
            <!-- Product Info -->
            <div class="flex items-center gap-4 w-[16rem] min-w-[16rem]">
              <img
                :src="payment.image"
                :alt="payment.name"
                class="min-w-[4rem] w-[4rem] h-[4rem] object-cover rounded-lg"
              />
              <div class="w-[12rem]">
                <h3 class="text-lg font-bold title-color truncate">
                  {{ payment.price }} FCFA
                </h3>
                <p class="truncate text-sm">
                  {{ payment.productName }}
                  {{ payment.productName }}
                  {{ payment.productName }}
                </p>
              </div>
            </div>

            <!-- Price and Quantity -->
            <div class="w-[8rem] min-w-[8rem]">
              <div class="font-bold title-color truncate">
                {{ payment.customerName }}
              </div>
              <div>{{ $Countries.find(payment.countryCode)?.countryName }}</div>
            </div>

            <!-- Price and Quantity -->
            <div class="flex gap-6 w-[8rem] min-w-[8rem]">
              <div>
                {{
                  $Commons.timestampToDate(payment.date, 'DD MMM YYYY, HH:mm')
                }}
              </div>
            </div>

            <!-- Price and Quantity -->
            <div class="flex gap-6 w-[8rem] min-w-[8rem]">
              <div>
                {{ paymentMethods[payment.paymentMethod] }}
              </div>
            </div>

            <div class="flex flex-col items-center w-[6rem] min-w-[6rem]">
              <button
                class="whitespace-nowrap px-4 py-2 font-medium text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg"
                :style="{
                  backgroundColor: statuses[payment.status]?.background,
                  color: statuses[payment.status]?.color,
                }"
              >
                {{ statuses[payment.status]?.name }}
              </button>
            </div>

            <div
              class="flex flex-col w-[16rem] min-w-[16rem] max-h-[4lh] overflow-hidden"
            >
              <div>
                {{ $t('transactions.detailedStatus.' + payment.statusMessage) }}
              </div>
            </div>

            <div
              class="flex items-center gap-2 w-[3rem] min-w-[3rem] justify-end relative pr-4"
            >
              <DropdownComponent
                :selects="[
                  {
                    name: 'Copier la référence',
                    onClick() {
                      $Commons.copy(payment.id || '-', 'Référence copiée')
                    },
                  },
                  ...(payment.status == 'success'
                    ? [
                        {
                          name: 'Lancer un Chargeback',
                          onClick() {
                            createChargeback(payment)
                          },
                        },
                      ]
                    : []),
                  {
                    name: 'Voir détails',
                    onClick() {
                      $Events.dispatchEvent(
                        'payment_details_requested',
                        payment,
                      )
                    },
                  },
                ]"
                hideArrow
                maxHeight="270px"
                displayKey="name"
                toLeft
                :onSelect="
                  selected => {
                    selected.onClick()
                  }
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
                  />
                </svg>
              </DropdownComponent>
            </div>
          </div>
        </div>
        <div class="py-2"></div>
        <div class="flex justify-center">
          <Pagination
            v-if="!isLoading"
            :currentPage="currentPage"
            :totalPages="totalPages"
            @pageClick="newPage => (currentPage = newPage)"
          />
        </div>
      </div>
    </div>
    <div
      class="h-[55vh] w-full flex-col items-center justify-center flex"
      v-else
    >
      <div class="w-1/6">
        <img src="@/assets/images/empty/no-payment.png" alt="" />
      </div>
      <div class="text-center">
        <div class="py-1"></div>
        <div class="text-4xl title-color font-bold">Aucun Paiement</div>
        <div class="py-1"></div>
        <div class="text-lg">Aucun paiement trouvé</div>
        <div class="py-3"></div>
      </div>
    </div>

    <EventListener
      :events="['chargeback_created', 'failed_to_create_chargeback']"
      @chargeback_created="onChargebackCreated"
      @failed_to_create_chargeback="onChargebackNotCreated"
    />
  </div>
</template>

<script>
import TransactionsGetter from '@/components/transaction/TransactionsGetter.vue'
import DataGetter from '@/components/utils/DataGetter.vue'
import DotLottieComponent from '@/components/utils/DotLottieComponent.vue'
import DropdownComponent from '@/components/utils/DropdownComponent.vue'
import EventListener from '@/components/utils/EventListener.vue'
import Pagination from '@/components/utils/Pagination.vue'

export default {
  name: 'homeComponent',
  components: {
    DataGetter,
    DropdownComponent,
    DotLottieComponent,
    TransactionsGetter,
    Pagination,
    EventListener,
  },
  data() {
    return {
      eventsIds: [],
      payments: [],
      activeTab: 'home',
      isLoading: true,
      isSearching: false,
      shimmerPayments: [
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
      ],
      paymentMethods: {
        card: 'Carte bancaire',
        mobileMoney: 'Mobile Money',
      },
      statuses: {
        '': {
          id: '',
          name: 'Tout',
          background: '#FFF0E7',
          color: '#BC5C2E',
        },
        pending: {
          id: 'pending',
          name: 'En attente',
          background: '#FFF0E7',
          color: '#BC5C2E',
        },
        success: {
          id: 'success',
          name: 'Réussi',
          background: '#EAEEFF',
          color: '#2930B5',
        },
        error: {
          id: 'error',
          name: 'Echoué',
          background: '#EEF2F3',
          color: '#696969',
        },
      },
      activeStatus: '',
      typedSearchValue: '',
      currentPage: 1,
      totalPages: 10,
    }
  },
  beforeUnmount() {
    this.eventsIds.map(this.$Events.removeHandler)
  },
  mounted() {},
  methods: {
    addNewProduct() {
      this.$Events.dispatchEvent('new_product_adding_required')
    },
    setPageIsLoading() {
      this.isLoading = true
    },
    async createChargeback(payment) {
      const prompt = await this.$Events.sendDataRequestResolve(
        'customPrompt',
        {
          title: `Voulez vous vraiment créer un charge back pour ce paiement de ${payment.price} FCFA ?`,
          subTitle: 'Ajouter un message descriptif de la raison du chargeback',
          formFields: [
            {
              type: 'text',
              propertyName: 'message',
              label: 'Message',
              defaultValue: '',

              required: true,
            },
          ],
          successText: 'Créer un chargeback',
          cancelText: 'Annuler',
        },
        9999999999,
      )
      if (!prompt.accepted) return null
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Création du chargeback en cours',
        body: 'Nous lançons le chargeback sur la transaction',
      })
      this.$Events.dispatchEvent('chargeback_creation_requested', {
        payment,
        message: prompt.data.message,
      })
    },
    onChargebackCreated() {
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Chargeback crée',
        body: 'Le chargeback a été créé avec succès',
      })
    },
    onChargebackNotCreated() {
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Echec de chargeback',
        body: "Nous n'avons pas pu créer le chargeback. Veuillez réessayer.",
      })
    },
  },
  watch: {
    currentPage() {
      this.isLoading = true
    },
    typedSearchValue() {
      this.isLoading = true
    },
    activeStatus() {
      this.isLoading = true
      this.currentPage = 1
    },
  },
}
</script>
